/**
 * Environment State — Types & Initial Values
 *
 * Defines the shape of the env slice and its starting state.
 * The env slice holds environment configuration that affects
 * how the app connects to APIs and renders (region, stage, theme).
 */
import { DEFAULT_REGION, getStageFromUrl, getApiBase } from '../../../constants';

/** Light or dark mode */
export type Theme = 'light' | 'dark';

/** Shape of the env slice state */
export interface EnvState {
  /** Currently selected AWS region (e.g. 'us-east-1') */
  region: string;
  /** Deployment stage derived from URL (Alpha, Beta, Gamma, Prod) */
  stage: string;
  /** Resolved API base URL for the current region + stage */
  apiBase: string;
  /** UI theme preference */
  theme: Theme;
}

const stage = getStageFromUrl();

/** Initial state — region defaults to us-east-1, stage auto-detected from URL */
export const envInitialState: EnvState = {
  region: DEFAULT_REGION,
  stage,
  apiBase: getApiBase(stage, DEFAULT_REGION),
  theme: 'light',
};
